import { NgModule } from '@angular/core';
import { SharedModule } from '../../shared.module';
import { AssessmentAiScribeComponent } from './assessment-ai-scribe.component';
import { ScribeFindingCardComponent } from './components/scribe-finding-card/scribe-finding-card.component';
import { ScribeOverwriteDialogComponent } from './components/scribe-overwrite-dialog/scribe-overwrite-dialog.component';
import { ScribeRecordTabComponent } from './components/scribe-record-tab/scribe-record-tab.component';
import { ScribeResultsPanelComponent } from './components/scribe-results-panel/scribe-results-panel.component';
import { ScribeTypeTabComponent } from './components/scribe-type-tab/scribe-type-tab.component';
import { ScribeConversationPanelComponent } from './components/scribe-conversation-panel/scribe-conversation-panel.component';

@NgModule({
  imports: [SharedModule],
  declarations: [
    AssessmentAiScribeComponent,
    ScribeRecordTabComponent,
    ScribeTypeTabComponent,
    ScribeFindingCardComponent,
    ScribeResultsPanelComponent,
    ScribeOverwriteDialogComponent,
    ScribeConversationPanelComponent
  ],
  exports: [AssessmentAiScribeComponent],
  entryComponents: [ScribeOverwriteDialogComponent]
})
export class AssessmentAiScribeModule {}
